import { FormEvent, useState } from 'react'
import { PencilIcon, PrinterIcon, XIcon } from '../icons'
import '../pos/ConfirmDialog.css'
import './StationDialog.css'

/**
 * Kategorinin tezgahı ve o tezgahın fişi basılsın mı (25 Eki 2026).
 *
 * Eskiden yalnız tezgah adı soran düz bir pencereydi. Bazı tezgahlar
 * siparişi yalnız mutfak ekranından takip ediyor, kağıda gerek yok; fiş
 * ayarı da tezgahın kendisinde, burada. Ayar tezgah adına bağlı: aynı
 * tezgahtaki bütün kategoriler için geçerli.
 */
export function StationDialog({
  categoryName,
  current,
  known,
  skipped,
  onSave,
  onManage,
  onClose,
}: {
  categoryName: string
  current: string
  /** İşletmedeki tezgahlar, seçilebilsin diye. */
  known: string[]
  /** Fişi basılmayan tezgahlar. */
  skipped: string[]
  onSave: (station: string, print: boolean) => void
  /** "Tezgahları düzenle": eklenen tezgahı silmek için. */
  onManage?: () => void
  onClose: () => void
}) {
  const [name, setName] = useState(current)
  const trimmed = name.trim()
  // Yazılan ad bilinen bir tezgahsa onun ayarıyla başlasın; elle değiştirilirse o kalsın.
  const [printByName, setPrintByName] = useState<Record<string, boolean>>({})
  const print = printByName[trimmed] ?? !skipped.includes(trimmed)
  const others = known.filter((s) => s !== trimmed)

  const submit = (e: FormEvent) => {
    e.preventDefault()
    if (!trimmed) return
    onClose()
    onSave(trimmed, print)
  }

  return (
    <div className="dlg" role="dialog" aria-modal="true" aria-label="Tezgah">
      <form className="dlg__card dlg__card--ask dlg__card--x stdlg" onSubmit={submit}>
        <button type="button" className="dlg__x" onClick={onClose} aria-label="Kapat">
          <XIcon />
        </button>
        <h2>"{categoryName}" hangi tezgahta?</h2>

        <label className="dlgfield">
          <span>Tezgah adı</span>
          <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Mutfak" />
        </label>

        {others.length > 0 && (
          <div className="stdlg__known">
            {others.map((s) => (
              <button key={s} type="button" className="stdlg__chip" onClick={() => setName(s)}>
                {s}
              </button>
            ))}
          </div>
        )}

        {onManage && (
          <button type="button" className="stdlg__manage" onClick={onManage}>
            <PencilIcon />
            Tezgahları düzenle
          </button>
        )}

        <div className={`stdlg__print ${print ? 'is-on' : ''}`}>
          <div className="stdlg__print-text">
            <b>Fiş basılsın</b>
            <small>
              {print
                ? 'Siparişler bu tezgahın yazıcısından fiş olarak çıkar.'
                : 'Fiş basılmaz, siparişler yalnız mutfak ekranında görünür.'}
            </small>
          </div>
          <button
            type="button"
            className={`stdlg__switch ${print ? 'is-on' : ''}`}
            role="switch"
            aria-checked={print}
            aria-label="Fiş basılsın"
            disabled={!trimmed}
            onClick={() => setPrintByName({ ...printByName, [trimmed]: !print })}
          >
            <span>
              <PrinterIcon />
            </span>
          </button>
        </div>
        <p className="stdlg__note">
          Aynı tezgaha yazılan kategoriler tek fişte birleşir; fiş ayarı da hepsi için geçerli.
        </p>

        <div className="dlg__buttons dlg__buttons--even">
          <button type="button" className="btn btn--ghost" onClick={onClose}>
            Vazgeç
          </button>
          <button type="submit" className="btn btn--primary" disabled={!trimmed}>
            Kaydet
          </button>
        </div>
      </form>
    </div>
  )
}
